import { UserRoles } from '@bb/users';
import type { AuthContextUser } from '../contexts';

export default (auth?: AuthContextUser) => {
  if (!auth) return false;

  if (auth.role === UserRoles.Owner) {
    return true;
  }
  if (
    (auth.role === UserRoles.Manager && auth.org.managerCanAccessBilling) ||
    (auth.role === UserRoles['Global Admin'] &&
      auth.org.globalAdminCanAccessBilling)
  ) {
    return true;
  }

  return false;
};
